export const formatCurrency = (amount: number | string | undefined | null, currencySymbol: string): string => {
  // 1. Penanganan jika nilai kosong atau tidak valid
  if (amount === undefined || amount === null || amount === '' || isNaN(Number(amount))) {
    return `${currencySymbol} 0`;
  }

  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  // 2. Pisahkan bagian integer dan desimal
  // Kita gunakan toFixed(2) dulu untuk menjaga presisi, lalu hapus nol di belakang
  const formattedValue = numAmount.toFixed(2);
  const [integerPart, decimalPart] = formattedValue.split('.');

  // 3. Format bagian ribuan dengan koma (,)
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 4. Logika Tampilan Desimal:
  // Jika desimalnya "00", jangan tampilkan apa-apa (Hasil: 75,000)
  // Jika ada angka selain nol (misal 75,000.50), tampilkan dengan titik
  if (decimalPart === '00') {
    return `${currencySymbol} ${formattedInteger}`;
  } else {
    // Menghapus nol tambahan di paling belakang desimal (misal 0.50 jadi 0.5)
    const cleanDecimal = decimalPart.replace(/0+$/, '');
    return `${currencySymbol} ${formattedInteger}.${cleanDecimal}`;
  }
};

// Format a number as Indonesian Rupiah.
// Uses "Rp" (no period) per PRD 6.1. Hides ".00" decimals for a cleaner UI,
// consistent with formatCurrency above.
export const formatRupiah = (amount: number | string | undefined | null): string => {
  if (amount === undefined || amount === null || amount === '') return '';

  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return '';

  const parts = num.toFixed(2).split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (decimalPart === '00') {
    return `Rp ${formattedInteger}`;
  }

  const cleanDecimal = decimalPart.replace(/0+$/, '');
  return `Rp ${formattedInteger}.${cleanDecimal}`;
};

export const formatDecimal = (amount: number | string | undefined | null, decimals: number = 2): string => {
  if (amount === undefined || amount === null || amount === '' || isNaN(Number(amount))) {
    return '0';
  }
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  const parts = num.toFixed(decimals).split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
  if (decimals === 0) return formattedInteger;
  
  return `${formattedInteger}.${decimalPart}`;
};

// Parse a Rupiah-formatted string back to a number.
// Handles both legacy "Rp." and current "Rp" prefixes for backward compatibility.
export const parseRupiah = (formatted: string): number => {
  if (!formatted) return 0;

  // Strip "Rp." or "Rp" prefix plus optional whitespace.
  const cleaned = formatted.replace(/Rp\.?\s?/i, '');

  // Remove commas (thousands separator)
  const normalized = cleaned.replace(/,/g, '');
  
  // normalized should now look like "150000" or "150000.50"
  const parsed = parseFloat(normalized);

  return isNaN(parsed) ? 0 : parsed;
};
